(function ($, undefined) {
	"use strict";

	let forwardPopup;
	let detailsPopup;
	let formValidator;
	let incidentDetailsPopup;

	function init() {
		formValidator = Fw.component.models().form;
		forwardPopup = $('.response-forward');
		detailsPopup = $('.response-details');
		incidentDetailsPopup = $('.incident-details');

		$('.response-forward__cancel').on('click', cancelResendResponse);
		$('.response-forward__send').on('click', resendResponse);
		$('.send-response-btn').on('click', setResponseId);

		$('.response-details-btn').on('click', populateDetails);
		$('.response-details__print').on('click', exportModalToPDF);
		$('.response-details__close').on('click', closeDetails);
		$('.incident-details__close').on('click', incidentCloseDetails);
		$('.stool-shared-popup-close-btn', detailsPopup).on('click', closeDetails);
		$(document).on('click', '.incident-details-updated-btn', incidentPopulateDetails);
	}


	function incidentPopulateDetails({ currentTarget }) {
		const $row = $(currentTarget);
		const incidentId = $row.attr('data-json');
		const date = $row.attr('data-date');
		const submitter = $row.attr('data-submitter');

		const button = document.querySelector(".incident-details__print");
		button.dataset.rowId = incidentId;

		// Show loader
		process(true);

		// Populate top info
		$('.incident-details__top .incident-details__info').eq(0).html("<span>Reported on: </span>" + date);
		$('.incident-details__top .incident-details__info').eq(1).html("<span>Reported by: </span>" + submitter);

		// Clear previous blocks
		const $blocks = $('.incident-details__blocks');
		$blocks.find('.incident-details-block:not(.incident-details-block_clone)').remove();

		// AJAX request to fetch incident details
		$.ajax({
			url: '/action/getIncidentDetails', // your backend endpoint
			method: 'GET',
			data: { id: incidentId },
			dataType: 'json',
			success: function (data) {
				const $clone = $('.incident-details-block_clone').clone().removeClass('incident-details-block_clone');

				$('.incident-details-block__title', $clone).text("Incident Details");

				// Helper to add rows like response style
				function addRow(label, value) {
					const row = $(`
            <div class="incident-details-block__row">
                <span class="incident-details-block__label">${label}:</span>
                <span class="incident-details-block__value">${value || '-'}</span>
            </div>
        `);
					$('.incident-details-block__description', $clone).append(row);
				}

				// Add fields
				addRow("Type", data.incidentType);
				addRow("Occurrence #", data.occurrenceNumber);
				addRow("Description", data.incidentDesc);
				addRow("Involved Persons", (Array.isArray(data.involvedPersons) && data.involvedPersons.length > 0)
					? data.involvedPersons.map(p => `${p.firstName} ${p.lastName}`).join(', ')
					: "-");
				addRow("Time of Incident", data.timeOfIncident);
				addRow("Emergency", data.anyEmergency ? "Yes" : "No");

				// Handle photos
				if (data.photos && data.photos.length > 0) {
					createImagePopup(); // Ensure popup exists
					const $btn = $('<button class="response-details-block__pic-btn sb-fw-bold-cblue">See Pictures</button>');
					$btn.on('click', function () { showImagePopup(data.photos); });

					const $btnWrapper = $('<div class="incident-details-block__pic-btn-wrapper"></div>');
					$btnWrapper.css({
						display: 'flex',
						justifyContent: 'flex-end',
						marginTop: '10px'
					});
					$btnWrapper.append($btn);

					$('.incident-details-block__description', $clone).append($btnWrapper);
				}

				// Append
				$('.incident-details__blocks').append($clone);
				process(false);
			},
			error: function (err) {
				console.error("Failed to fetch incident details", err);
				process(false);
			}
		});
	}

	// Create popup dynamically (only once)
	function createImagePopup() {
		if ($('#imagePopup').length > 0) return; // already exists

		const popupHtml = `
		<div id="imagePopup" class="image-popup" style="display:none;">
			<div class="image-popup-content">
				<span class="image-popup-close">&times;</span>
				<div id="imagePopupContainer" class="image-popup-container"></div>
			</div>
		</div>
	`;

		$('body').append(popupHtml);

		// Add CSS dynamically
		const styles = `
		.image-popup {
			position: fixed;
			top: 0; left: 0;
			width: 100%; height: 100%;
			background: rgba(0,0,0,0.7);
			display: flex; justify-content: center; align-items: center;
			z-index: 9999;
		}
		.image-popup-content {
			background: #fff;
			padding: 15px;
			border-radius: 10px;
			width: 500px;          /* not full width */
			max-width: 90%;
			max-height: 85%;
			overflow-y: auto;
			position: relative;
			box-shadow: 0 4px 20px rgba(0,0,0,0.3);
		}
		.image-popup-container {
			display: flex;
			flex-direction: column;
			align-items: center;
		}
		.image-popup-container img {
			max-width: 100%;
			margin: 10px 0;
			border-radius: 6px;
			display: none; /* hide until loaded */
		}
		.image-popup-loader {
			border: 4px solid #f3f3f3;
			border-top: 4px solid #3498db;
			border-radius: 50%;
			width: 40px; height: 40px;
			animation: spin 1s linear infinite;
			margin: 20px auto;
		}
		@keyframes spin {
			0% { transform: rotate(0deg); }
			100% { transform: rotate(360deg); }
		}
		.image-popup-close {
			position: absolute;
			top: 10px; right: 20px;
			font-size: 30px;
			font-weight: bold;
			color: #333;
			cursor: pointer;
		}
	`;
		$('<style>').text(styles).appendTo('head');

		// Close handler
		$(document).on('click', '.image-popup-close', function () {
			$('#imagePopup').hide();
		});
	}
	function showImagePopup(photoIds) {
		const $popup = $('#imagePopup');
		const $container = $('#imagePopupContainer');

		$container.empty();

		photoIds.forEach(id => {
			const wrapper = $('<div style="width:100%; text-align:center;"></div>');
			const loader = $('<div class="image-popup-loader"></div>');
			const img = $('<img>').attr('src', `/action/sbHandleFile?id=${id}`);

			// Show loader until image loads
			img.on('load', function () {
				loader.remove();
				img.fadeIn();
			});

			wrapper.append(loader).append(img);
			$container.append(wrapper);
		});

		$popup.show();
	}



	function populateDetails({ currentTarget }) {
		process(true);
		let { date, itemId, json, submitter } = currentTarget.dataset;
		let clone = $('.response-details-block_clone').clone().removeClass('response-details-block_clone');
		let time = detailsPopup.find('.response-details__info').eq(0);
		let author = detailsPopup.find('.response-details__info').eq(1);

		setValue(time, date);
		setValue(author, submitter);

		$(document.body).addClass('response-details-print');

		setQuestions(clone, JSON.parse(json).questions);

		const button = document.querySelector(".response-details__print");
		button.dataset.rowId = itemId;

		process(false);
	}

	function setValue($elt, value) {
		// $elt.html($elt.html().replace(`{{ ${key} }}`, value));
		$elt.html($elt.find("span").prop('outerHTML') + value);
	}

	function setQuestions(clone, questions) {
		let blocks = $('.response-details__blocks');
		let questionBlocks = questions.map(question => {
			return getQuestionBlock(clone, question);
		});

		blocks.find('.response-details-block:not(.response-details-block_clone)').remove();
		blocks.append(questionBlocks);
	}

	function getQuestionBlock(clone, question) {
		let newClone = clone.clone();
		let image = $('.response-details-block__pic', newClone);
		let title = $('.response-details-block__title', newClone);
		let description = $('.response-details-block__description', newClone);
		let responseParagraph = $('.response-details-block__response', newClone);
		let answer = $('.response-details-block__answer', newClone);
		let nfc = $('.response-details-block__nfc', newClone);
		let time = $('.response-details-block__answer-time', newClone);
		let btn = $('.response-details-block__pic-btn', newClone);
		let date = question.hasOwnProperty('date') ? isNaN(Number(question.date)) ? new Date(question.date) : new Date(Number(question.date)) : null;
		let formattedDate = date != null ? formatDate(date) : '';
		let response = question.response == "true" ? "Yes" : question.response == "false" ? "No" : question.response;
		let nfcAnswer = question.NFCValidation ? (question.NFCValidated ? "NFC Validated" : "NFC Not Validated") : "";
		let deficiency = $('.response-details-block__deficiency', newClone);

		if (question.hasOwnProperty('deficiency')) {
			newClone.addClass('response-details-block_deficiency');
			deficiency.text(question.deficiency);
		}

		let nfcNotScanned = $('.response-details-block__nfc-not-scanned', newClone);
		if (question.hasOwnProperty('NFCValidated') && question.NFCValidated === false) {
			if (!question.hasOwnProperty('deficiency')) {
				newClone.addClass('response-details-block_nfc-not-scanned');
			}
			nfcNotScanned.text("NFC Not Scanned: " + (question.nfcReason && question.nfcReason != undefined ? question.nfcReason : "-"));
			nfcNotScanned.addClass("d-block");
		}

		answer.text(response);
		nfc.text(nfcAnswer);
		title.text(question.name);
		time.text(formattedDate);
		description.text(question.description);

		if (question.hasOwnProperty('picture')) {
			image.attr('src', `/action/sbHandleFile?id=${question.picture}`);
			image.hide(); // start hidden

			btn.off('click').on('click', function () {
				image.toggle();
				$(this).text(image.is(':visible') ? 'Hide picture' : 'See picture');
			});
		} else {
			image.remove();
			btn.remove();
		}

		return newClone;
	}


	function formatDate(oldDate) {
		var date = new Date(oldDate.toLocaleString("en-US", { timeZone: 'America/New_York' }));
		console.warn("date: ", date);
		let day = date.getDate();
		let month = date.getMonth() + 1;
		let year = date.getFullYear();
		let hour = date.getHours();
		let meridiemHour = hour % 12 == 0 && hour == 12 ? 12 : hour % 12;
		let minute = date.getMinutes();
		let meridiem = hour >= 12 ? 'PM' : 'AM';

		minute = minute < 10 ? "0" + minute : minute; hour = hour < 10 ? "0" + hour : hour; meridiemHour = meridiemHour < 10 ? "0" + meridiemHour : meridiemHour;

		if (document.documentElement.lang == 'fr') {

			return `${day}/${month}/${year.toString().substring(2)} ${hour}:${minute}`;
		} else {

			return `${month}/${day}/${year.toString().substring(2)} ${meridiemHour}:${minute} ${meridiem}`;
		}
	}

	function toggleImageVisibility({ currentTarget }) {
		let ctn = $(currentTarget).closest('.response-details-block');
		let image = ctn.find('.response-details-block__pic');
		let visible = image.hasClass('response-details-block__pic_visible');

		image.toggleClass('response-details-block__pic_visible', !visible);
	}

	async function exportModalToPDF() {
		const button = document.querySelector(".response-details__print");
		if (!button) {
			return;
		}

		const ctx = resolveResponseExportContext(button);
		let rowId = ctx.rowId;
		const viewType = ctx.viewType;
		const formId = ctx.formId;
		const submissionId = ctx.submissionId;
		const locationName = ctx.locationName;
		const formName = ctx.formName;
		const submittedAt = ctx.submittedAt;
		let userId = document.getElementById("userId");
		let personId = userId ? userId.value : "";

		if (viewType === "form") {
			if (!formId || !submissionId) {
				alert("Could not download this form submission. Missing form or submission id.");
				return;
			}
		} else if (rowId && rowId.indexOf("DYN_") === 0) {
			rowId = (window.rowDataKeyCache && window.rowDataKeyCache[rowId])
				? window.rowDataKeyCache[rowId]
				: rowId;
		}

		const baseUrl = window.location.origin;
		const domain = window.location.hostname;
		let url;

		if (viewType === "form") {
			url = domain === "localhost"
				? `http://localhost:9006/public/interactive-form/${encodeURIComponent(formId)}/submissions/${encodeURIComponent(submissionId)}/pdf?personId=${encodeURIComponent(personId)}`
				: `${baseUrl}/pdf-service/public/interactive-form/${encodeURIComponent(formId)}/submissions/${encodeURIComponent(submissionId)}/pdf?personId=${encodeURIComponent(personId)}`;
		} else {
			url = domain === "localhost"
				? `http://localhost:9101/public/export/modal?ResponseID=${encodeURIComponent(rowId)}&personId=${encodeURIComponent(personId)}`
				: `${baseUrl}/analyticservice/public/export/modal?ResponseID=${encodeURIComponent(rowId)}&personId=${encodeURIComponent(personId)}`;
		}

		// Inject CSS for spinner only once
		if (!document.getElementById("spinner-style")) {
			const style = document.createElement("style");
			style.id = "spinner-style";
			style.innerHTML = `
			.btn-spinner {
				width: 18px;
				height: 18px;
				border: 2px solid #fff;
				border-top-color: #54834D;
				border-radius: 50%;
				animation: spin 0.6s linear infinite;
				display: inline-block;
				vertical-align: middle;
			}
			@keyframes spin {
				to { transform: rotate(360deg); }
			}
		`;
			document.head.appendChild(style);
		}

		const originalText = button.textContent;

		try {
			button.disabled = true;
			button.innerHTML = `<span class="btn-spinner"></span>`;

			const response = await fetch(url, { method: "GET" });

			if (!response.ok) throw new Error("Failed to fetch PDF");

			const blob = await response.blob();
			const link = document.createElement("a");
			link.href = window.URL.createObjectURL(blob);
			link.download = viewType === "form"
				? buildFormSubmissionPdfFilename(locationName, formName, submittedAt)
				: "response.pdf";
			link.click();

			window.URL.revokeObjectURL(link.href);
		} catch (err) {
			console.error("PDF download failed:", err);
			alert("PDF download failed. Please try again.");
		} finally {
			button.disabled = false;
			button.textContent = originalText || "Download";
		}
	}

	function getCachedRowData(rowId) {
		if (!rowId || typeof window.rowDataCache === "undefined") {
			return null;
		}

		let cached = window.rowDataCache[rowId];
		if (typeof cached === "string") {
			try {
				cached = JSON.parse(cached);
			} catch (e) {
				return null;
			}
		}

		return cached;
	}

	function sanitizeFilenamePart(value, fallback) {
		const s = (value == null ? "" : String(value)).trim();
		if (!s) {
			return fallback || "unknown";
		}
		return s
			.replace(/[\\/:*?"<>|]/g, "_")
			.replace(/\s+/g, "_")
			.replace(/_+/g, "_")
			.replace(/^_|_$/g, "");
	}

	function ordinalSuffixForFilename(day) {
		if (day >= 11 && day <= 13) {
			return "th";
		}
		switch (day % 10) {
			case 1: return "st";
			case 2: return "nd";
			case 3: return "rd";
			default: return "th";
		}
	}

	function formatTimestampForFilename(dateStr) {
		const parseDate = function (raw) {
			if (!raw) {
				return new Date();
			}
			const cleaned = String(raw).replace(/\b(\d{1,2})(st|nd|rd|th)\b/gi, "$1");
			const parsed = new Date(cleaned);
			return isNaN(parsed.getTime()) ? new Date() : parsed;
		};
		const d = parseDate(dateStr);
		const months = [
			"january", "february", "march", "april", "may", "june",
			"july", "august", "september", "october", "november", "december"
		];
		const day = d.getDate();
		const pad = function (n) {
			return n < 10 ? "0" + n : String(n);
		};
		return day + ordinalSuffixForFilename(day) + "_"
			+ months[d.getMonth()] + "_"
			+ d.getFullYear() + "_"
			+ pad(d.getHours()) + "_"
			+ pad(d.getMinutes());
	}

	function buildFormSubmissionPdfFilename(locationName, formName, submittedAt) {
		const loc = sanitizeFilenamePart(locationName, "location");
		const form = sanitizeFilenamePart(formName, "form");
		const ts = formatTimestampForFilename(submittedAt);
		return loc + "_" + form + "_" + ts + ".pdf";
	}

	function resolveResponseExportContext(button) {
		const rowId = button.dataset.rowId || "";
		const cached = getCachedRowData(rowId);
		const meta = (window.rowDataMetaCache && window.rowDataMetaCache[rowId]) || {};

		let viewType = button.dataset.viewType || meta.viewType || "";
		let formId = button.dataset.formId || meta.formId || "";
		let submissionId = button.dataset.submissionId || meta.submissionId || "";
		let locationName = button.dataset.locationName || meta.locationName || "";
		let formName = button.dataset.formName || meta.formName || "";
		let submittedAt = button.dataset.submittedAt || meta.submittedAt || "";

		if (cached && Array.isArray(cached.fields)) {
			viewType = "form";
			formId = formId || cached.formId || cached.form_id || "";
			submissionId = submissionId || cached.submissionId || cached.submission_id || "";
		}

		if (window.activeResponseDetailsExport && window.activeResponseDetailsExport.rowId === rowId) {
			viewType = window.activeResponseDetailsExport.viewType || viewType;
			formId = window.activeResponseDetailsExport.formId || formId;
			submissionId = window.activeResponseDetailsExport.submissionId || submissionId;
			locationName = window.activeResponseDetailsExport.locationName || locationName;
			formName = window.activeResponseDetailsExport.formName || formName;
			submittedAt = window.activeResponseDetailsExport.submittedAt || submittedAt;
		}

		return {
			rowId: rowId,
			viewType: viewType,
			formId: formId,
			submissionId: submissionId,
			locationName: locationName,
			formName: formName,
			submittedAt: submittedAt
		};
	}

	function closeDetails() {
		detailsPopup.find('.stool-shared-popup-close-btn').off('click', closeDetails);
		$(document.body).removeClass('response-details-print');
		detailsPopup.removeClass('visible');
	}

	function incidentCloseDetails() {
		incidentDetailsPopup.find('.stool-shared-popup-close-btn').off('click', incidentCloseDetails);
		$(document.body).removeClass('incident-details-print');
		incidentDetailsPopup.removeClass('visible');
	}

	function setResponseId({ currentTarget }) {
		$('.response-forward__send').attr('data-id', currentTarget.dataset.itemId);
		var message = "The response was successfully forwarded.";
		var itemType = currentTarget.dataset.itemType;

		if (itemType == "sbSendShiftReport" || itemType == "settings-shift-report" || itemType == "incident" || itemType == "settings-incident-report"
			|| itemType == "settings-subscription") {
			if (itemType == "settings-shift-report" || itemType == "settings-incident-report" || itemType == "settings-subscription") {
				message = "The notifications settings was successfully saved.";
				$('.response-forward__send').text("Save");
				$('.response-forward__send').attr('data-item-gid', currentTarget.dataset.itemGid);
			} else {
				message = "The " + (itemType == "sbSendShiftReport" ? "shift" : "incident") + " report was successfully forwarded.";
				$('.response-forward__send').text("Send");
			}
		} else $('.response-forward__send').text("Send");
		$('.response-forward__send').attr('data-item-success-msg', message);

	}

	function cancelResendResponse() {
		forwardPopup.removeClass('visible');
		resetForm(forwardPopup.find('form'));
		forwardPopup.find('.form-message').hide();
	}

	function resendResponse({ currentTarget }) {
		let form = forwardPopup.find('form');
		forwardPopup.find('.form-message_success').text(currentTarget.dataset.itemSuccessMsg);
		var itemType = currentTarget.dataset.itemType;

		if (itemType == "settings-subscription") {
			process(true);
			var emails = getResendEmailGeneric(true, "-").join();
			$("input[name='subscribers']").val(emails);
			forwardPopup.find('.form-message_success').show();
			process(false);
		} else if (itemType == "settings-shift-report" || itemType == "settings-incident-report") {
			forwardPopup.find('.form-message').hide();
			formValidator.validateForm(form);

			if (form.hasClass('has-error')) {
				forwardPopup.find('.form-message_email').show();
			} else {
				process(true);
				var emails = getResendEmailGeneric(true, "-").join();
				var itemGid = currentTarget.dataset.itemGid;
				var params = {
					ajax: true,
					id: itemGid
				};

				params["field" + (itemType == "settings-shift-report" ? "30" : "27")] = emails;
				$.ajax({
					url: '/action/manageGenData',
					data: params,
					method: 'POST',
					success: function () {
						$("input[name='field" + (itemType == "settings-shift-report" ? "30" : "27") + "']").val(emails);
						process(false);
						forwardPopup.find('.form-message_success').show();
					},
					error: resendError
				});
			}
		} else {
			forwardPopup.find('.form-message').hide();
			formValidator.validateForm(form);

			let url = '/action/' + (itemType != undefined && itemType != null ? 'sbSendReport?reportType=' + itemType : 'sbSendResponse');
			if (form.hasClass('has-error')) {
				forwardPopup.find('.form-message_email').show();
			} else {
				process(true);
				$.ajax({
					url: url,
					type: 'POST',
					data: {
						email: getResendEmails(itemType == "shift" || itemType == "incident").join(),
						resend: currentTarget.dataset.id,
						ajax: true,
					},
					success: resendSuccess,
					error: resendError
				});
			}
		}
	}

	function getResendEmails(isReport) {
		return getResendEmailGeneric(isReport, "");
	}

	function getResendEmailGeneric(isReport, seperator) {
		let checkbox = isReport ? $(".stool-shared-popup.stool-shared-popup-outer").find('.response-forward__person-check:checked') : forwardPopup.find('.response-forward__person-check:checked');
		let emailInput = isReport ? $(".stool-shared-popup.stool-shared-popup-outer").find('.response-forward__email') : forwardPopup.find('.response-forward__email');
		let emails = checkbox.map((i, c) => c.value).get();

		if (emailInput.val().length) {
			emails = emails.concat(((seperator == "" ? "" : seperator + ",") + emailInput.val()).split(','));
		}

		return emails;
	}

	function resendSuccess() {
		process(false);
		resetForm(forwardPopup.find('form'));
		forwardPopup.find('.form-message_success').show();
	}

	function resendError() {
		process(false);
		forwardPopup.find('.form-message_server').show();
	}

	function resetForm(form) {
		form.get(0).reset();
	}

	function process(show) {
		$('.site-overlay').toggleClass('site-overlay_processing', show);
	}

	$(init);

})(jQuery);